<template>
  <div class="box9">
    <pageTitle 
      title="6大服务保障  为学习效果负责" 
      text=""
      titleColor="#332114"
      titColor=""
    />
    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <div class="title">{{ item.title }}</div>
            <ul>
              <li v-for="(child, i) in item.children" :key="i">
                <h3>{{ child.title }}</h3>
                <p>{{ child.text }}</p>
              </li>
            </ul>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
  import pageTitle from "../common/pageTitle.vue";
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  export default {
    components: {
      pageTitle,
      swiper,
      swiperSlide,
    },
    name: '',
    data() {
      return {
        cur: 0,
        swiperOption: {
          slidesPerView: "auto",
          spaceBetween: 16,
          pagination: {
            el: ".swiper-pagination-box3",
          },
        },
        list: [
          {
            title: "基础服务",
            children: [
              {
                title: '陪伴式学习',
                text: '从报名到考试结束班主任全程“陪跑”'
              },
              {
                title: '直播答疑',
                text: '定期直播答疑+群内技术答疑'
              },
              {
                title: '学习交流',
                text: '进班后进专属交流学习群，提升学习氛围'
              }
            ],
            url: require("../../../assets/coursePage/acp/box9/img1.png"),
          },
          {
            title: "学习资料",
            children: [
              {
                title: '配套课件',
                text: '课程配套教辅课件全部赠送'
              },
              {
                title: '海量模拟题',
                text: '考前海量模拟题全提供'
              },
              {
                title: '指导手册',
                text: '考试大纲、课程大纲、认证指引手册全提供'
              }
            ],
            url: require("../../../assets/coursePage/acp/box9/img2.png"),
          },
        ],
      }
    }
  }
</script>

<style lang="scss" scoped>
.box9{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/acp/box9/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}  
.subject-content {
  position: relative;
  margin-top: 70px;
  box-sizing: border-box;

  .block {
    position: relative;
    padding: 36px 0 0 40px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .title {
      margin-bottom: 32px;
      font-size: 28px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: #1d2129;
      line-height: 44px;
      margin-left: 80px;
    }

    ul {
      li {
        width: 480px;
        height: 108px;
        background-color: #fff8f7;
        box-shadow: 0px 0px 20px 0px #ffd1cc;
        border-radius: 20px;
        border: solid 2px #ffffff;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 14px 0 0 20px;
        h3 {
          font-family: PingFangSC-Medium;
          font-size: 28px;
          font-weight: 600;
          font-stretch: normal;
          line-height: 38px;
          letter-spacing: 0px;
          color: #332114;
          margin-bottom: 10px;
        }
        p { 
          font-family: PingFang-SC-Regular;
          font-size: 24px;
          line-height: 28px;
          color: #4d3f36;
        }
      }
    }
  }
}

.swiper-slide {
  width: 560px;
	height: 526px;
	background-color: #fff1f0;
	border-radius: 30px;
	border: dashed 2px #ff5e4d;
  box-sizing: border-box;
  background: url(../../../assets/coursePage/acp/box9/img1.png) no-repeat 20px 17px;
  background-size: 102px 102px;
  &:last-child {
    background-color: #fff0e5;
	  border: dashed 2px #ff791a;
    margin-right: 30px !important;
  }
  &:first-child {
    margin-left: 30px !important;
  }
}

.swiper-pagination-box3 {
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 0px;
  transform: translate(-50%, 0px);
  height: 6px;
  background: rgba(46, 165, 252, 0.16);
  border-radius: 3px;
}

</style>